// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }
// enableProdMode();
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";
import {
  enableProdMode,
  APP_INITIALIZER,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { JwtInterceptor } from "./app/core/helpers/jwt.interceptor";
import { ErrorInterceptor } from "./app/core/helpers/error.interceptor";
import { CorsInterceptor } from "./app/core/helpers/cors.interceptor";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { AuthInterceptor } from "./app/core/helpers/auth.interceptor";
import { LightboxModule } from "ngx-lightbox";
// Enable production mode if in production environment
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CorsInterceptor, multi: true },
    ...appConfig.providers,
    provideAnimationsAsync(),
    provideAnimationsAsync("noop"),
    provideAnimationsAsync("noop"),
    importProvidersFrom(LightboxModule),
  ],
}).catch((err) =>
  console.error("Error during bootstrapping the application:", err),
);
